import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import { OpenInNew } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const SpareCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [description, setDescription] = useState("");
    const [hsnCode, setHSNCode] = useState("");
    const [saleRate, setSaleRate] = useState("");
    const [purchaseRate, setPurchaseRate] = useState("");
    const [gstRate, setGstRate] = useState("");
    const [openingStock, setOpeningStock] = useState("");
    const [currentStock, setCurrentStock] = useState("");
    const [minimumStock, setMinimumStock] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [totalStock, setTotalStock] = useState("");

    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const clearForm = () => {
        setName("");
        setCode("");
        setDescription("");
        setHSNCode("");
        setSaleRate("0");
        setPurchaseRate("0");
        setGstRate("0");
        setOpeningStock("0");
        setCurrentStock("0");
        setMinimumStock("0");
        setTotalStock("0");
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!name) {
            setErrorMessage("All fields are required!");
            setisSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            CompanyId: companyId,
            Name: name,
            Code: code,
            Description: description,
            HSNCode: hsnCode,
            GSTRate: gstRate,
            SaleRate: saleRate,
            PurchaseRate: purchaseRate,
            OpeningStock: openingStock,
            CurrentStock: currentStock,
            TotalStock: totalStock,
            MinimumStock: minimumStock,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('SparePartsApi', CreateData, token)
            .then((response) => {
                console.log('Spareparts Created success:', response);
                setSuccessMessage("Spareparts Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/SpareIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SPARE PARTS CREATE</h6>

                        <Tooltip title="Exit">
                            <Link to="/SpareIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>

                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">



                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                                maxLength={50}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                type="text"
                                placeholder="Enter Code"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                HSNCode
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={hsnCode}
                                onChange={(e) => setHSNCode(e.target.value)}
                                type="text"
                                placeholder="Enter HSNCode"
                                maxLength={7}
                            />
                        </div>
                    </div>
                    <div className="w-full mb-4 flex">


                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Description
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                                maxLength={100}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                GST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={gstRate}
                                //onChange={(e) => setGstRate(e.target.value)}
                                onChange={(e) => {
                                    const gRateValue = e.target.value.replace(/\D/g, '');
                                    setGstRate(gRateValue);
                                }}
                                type="text"
                                placeholder="Enter GST Rate"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Purchase Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={purchaseRate}
                                // onChange={(e) => setPurchaseRate(e.target.value)}
                                onChange={(e) => {
                                    const PRateValue = e.target.value.replace(/\D/g, '');
                                    setPurchaseRate(PRateValue);
                                }}
                                type="text"
                                placeholder="Enter Purchase Rate"
                                maxLength={5}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Sale Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={saleRate}
                                // onChange={(e) => setSaleRate(e.target.value)}
                                onChange={(e) => {
                                    const sRateValue = e.target.value.replace(/\D/g, '');
                                    setSaleRate(sRateValue);
                                }}
                                type="text"
                                placeholder="Enter Sale Rate"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                OpenningStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={openingStock}
                                // onChange={(e) => setOpeningStock(e.target.value)}
                                onChange={(e) => {
                                    const openValue = e.target.value.replace(/\D/g, '');
                                    setOpeningStock(openValue);
                                }}
                                type="text"
                                placeholder="openning Stock"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                TotalStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={totalStock}
                                //onChange={(e) => setTotalStock(e.target.value)}
                                onChange={(e) => {
                                    const totValue = e.target.value.replace(/\D/g, '');
                                    setTotalStock(totValue);
                                }}
                                type="text"
                                placeholder="Total stock"
                                maxLength={5}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                CurrentStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={currentStock}
                                // onChange={(e) => setCurrentStock(e.target.value)}
                                onChange={(e) => {
                                    const currentValue = e.target.value.replace(/\D/g, '');
                                    setCurrentStock(currentValue);
                                }}
                                type="text"
                                placeholder="current stock"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                MinimumStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={minimumStock}
                                // onChange={(e) => setMinimumStock(e.target.value)}
                                onChange={(e) => {
                                    const minValue = e.target.value.replace(/\D/g, '');
                                    setMinimumStock(minValue);
                                }}
                                type="text"
                                placeholder="Minimum stock"
                                maxLength={5}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}

export default SpareCreate;

